import { useQuery } from '@apollo/client'
import { GetUserByToken, GetUserByTokenVariables } from '../../types'
import { USER_BY_TOKEN } from './operations'

interface Props {
  token: string
  onCompleted?: (data: GetUserByToken) => void
  skip?: boolean
}

export const useGetUserByToken = ({ token, onCompleted, skip }: Props) =>
  useQuery<GetUserByToken, GetUserByTokenVariables>(USER_BY_TOKEN, {
    variables: { token },
    onCompleted,
    skip,
  })
